// What is Site Code: https://support.wix.com/en/article/corvid-working-in-the-code-panel

$w.onReady(function () {
	// Write your code here
});